// extracted by mini-css-extract-plugin
export var filterIncDec = "_es-0";
export var leftBorder = "_es-1";
export var rightBorder = "_es-2";
export var stringInput = "_es-3";